/* eslint import/no-cycle: 0 */
import React from 'react'

import { If } from '../../../../components/if/if'
import { NoContentText } from '../../../../components/table/styles'
import { ClientsAssessmentsListProps } from './props'
import StarFeedback from './star-feedback'
import TextFeedback from './text-feedback'

import {
  Container,
  Card,
  CardkHeader,
  Title,
  FeedbackList,
  StarFeedbackList,
} from './styles'

const ClientsAssessmentsList = ({
  assessments,
  starFeedbacks,
}: ClientsAssessmentsListProps) => (
  <Container>
    <Card>
      <CardkHeader>
        <Title>Média de avaliações</Title>
      </CardkHeader>
      <StarFeedbackList>
        {
          starFeedbacks.map((assessment) => (
            <StarFeedback assessment={assessment} />
          ))
        }
        <If condition={assessments?.length === 0 || !assessments}>
          <NoContentText>Sem avaliações</NoContentText>
        </If>
      </StarFeedbackList>
    </Card>
    <Card>
      <CardkHeader>
        <Title>Feedback</Title>
      </CardkHeader>
      <FeedbackList>
        {
          assessments.map((assessment: any) => (
            <TextFeedback
              key={assessment.answer}
              data={assessment}
            />
          ))
        }
        <If condition={assessments?.length === 0 || !assessments}>
          <NoContentText>Sem avaliações</NoContentText>
        </If>
      </FeedbackList>
    </Card>
  </Container>
)

export default ClientsAssessmentsList
